document.addEventListener("DOMContentLoaded", () => {

    const form = document.querySelector('form[data-type="add-to-cart-form"]');

    if(!form) return;

    form.addEventListener("submit", async () => {

        const checkbox=document.getElementById("extra-dolly-checkbox");

        if(!checkbox || !checkbox.checked) return;

        await fetch("/cart/add.js",{

            method:"POST",

            headers:{
                "Content-Type":"application/json"
            },

            body:JSON.stringify({

                id:checkbox.dataset.variantId,

                quantity:1

            })

        });

    });

});

document.addEventListener("DOMContentLoaded", function () {

    const checkbox = document.getElementById("extra-dolly-checkbox");

    if (!checkbox) return;

    checkbox.addEventListener("change", function () {

        document.getElementById("extra-dolly-selected").value =
            this.checked ? "Yes" : "No";

    });

});